import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { fromJS } from 'immutable'
import { actions } from 'react-redux-form/immutable'

import CoverModal from 'components/CoverModal'
import ConfirmDialog from 'components/ConfirmDialog'
import FormAdvising from 'containers/Enrolment/form-advising'
import { makeGetSelected } from 'containers/Enrolment/selectors'
import { apply } from 'containers/Enrolment/actions'

import ListOfferings from './list-offerings'
import ListSelected from './list-selected'

class FormContainer extends Component {

  constructor(props) {
    super(props)

    this.state = {
      showOfferings: false,
      showAffirm: false,
    }
  }

  _showOfferings = () => {
    this.setState({
      showOfferings: true,
    })
  }

  _hideOfferings = () => {
    this.setState({
      showOfferings: false,
    })
  }

  _showAffirm = () => {
    this.setState({
      showAffirm: true,
    })
  }

  _hideAffirm = () => {
    this.setState({
      showAffirm: false,
    })
  }

  _submit = () => {
    const { __selected, __semcampID, dispatch } = this.props
    dispatch(apply(__selected, __semcampID))
      .then((res) => {
        if (!res.error) {
          // set advising state
          dispatch(actions.change('advisingState', fromJS(res.payload.advising)))
          // set enrolledState
          dispatch(actions.change('enrolledState', fromJS(res.payload.subjects)))
          // redirect to modify
          this.context.router.replace('/enrolment/modify')
        }
      })
  }

  _renderOfferings() {
    const { showOfferings } = this.state
    if (!showOfferings) {
      return null
    }

    return (
      <CoverModal handleClose={this._hideOfferings} modalClass="subject">
        <ListOfferings
          handleClose={this._hideOfferings}
        />
      </CoverModal>
    )
  }

  _renderAffirm() {
    const { showAffirm } = this.state
    const { __pending } = this.props
    if (!showAffirm) {
      return null
    }

    return (
      <ConfirmDialog
        msg="Confirm submit application?"
        closeDialog={this._hideAffirm}
        confirmAction={this._submit}
        btnClass="btn-success"
        pending={__pending}
      />
    )
  }

  render() {
    return (
      <div>
        <div className="row m-b-20">
          <div className="col-sm-6">
            <button onClick={this._showOfferings} type="button" className="btn btn-info">Subject Offerings</button>
          </div>
          <div className="col-sm-6 text-right">
            <button onClick={this._showAffirm} className="btn btn-success">Submit Application for Enrolment</button>
          </div>
        </div>
        <FormAdvising legend="Apply for Enrolment" />
        <ListSelected />
        {this._renderOfferings()}
        {this._renderAffirm()}
      </div>
    )
  }
}

FormContainer.contextTypes = {
  router: PropTypes.object,
}

FormContainer.propTypes = {
  __selected: PropTypes.object,
  __pending: PropTypes.bool,
  __semcampID: PropTypes.number,
}

function mapStateToProps(state) {
  const getSelected = makeGetSelected()
  return {
    __selected: getSelected(state),
    __pending: state.enrolment.get('pending'),
    __semcampID: state.auth.getIn(['me', 'semcamp_id']),
  }
}


export default connect(mapStateToProps)(FormContainer)



// WEBPACK FOOTER //
// ./src/containers/Enrolment/Apply/form-container.js